import React from 'react';
import { Card } from '../../../components/Card/Card';
import { Seatmap } from '../../../components/Seatmap/Seatmap';
import { t } from '../../../locales/translate';
import { SeatmapEditCategoryBox } from '../../../components/Seatmap/SeatmapEditCategoryBox';

interface Props {
  venueLayoutId: string;
  onChange: () => void;
}

export function VenueLayoutSeatMap({ venueLayoutId, onChange }: Props): JSX.Element {
  return (
    <Card title={t.model.venueLayout.seats}>
      <Seatmap layoutId={venueLayoutId} mode="pricing-category">
        {({ seatmap }) => {
          return (
            seatmap.structureEditable &&
            seatmap.selection.type && (
              <>
                <SeatmapEditCategoryBox
                  seatmap={seatmap}
                  onChange={onChange}
                  onClose={() => seatmap.selection.clear()}
                />
              </>
            )
          );
        }}
      </Seatmap>
    </Card>
  );
}
